import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_getDataPCDByPchID = (pch_id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.API_PETTYCASH_D}` + `/getby-pch_id/${pch_id}`);
};
export const billing_expense_createPCD = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.API_PETTYCASH_D}` + `/create`, data);
};
export const billing_expense_updatePCD = (id, data) => {
    return httpClient.put(`${billing_expense.billing_expense_url}/${server.API_PETTYCASH_D}` + `/update/${id}`, data);
};

export const billing_expense_deletePCD = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.API_PETTYCASH_D}` + `/delete/${id}`);
};

